import { ThermometerChevronUpIcon } from './ThermometerChevronUpIcon';

/**
 * author: Michael Richins
 * id 79E7C071-7AEE-48B1-802E-922925E94247
 * name thermometer-chevron-up
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-chevron-up.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const ThermometerIncreaseIcon = ThermometerChevronUpIcon;
export default ThermometerIncreaseIcon